import Vue from 'vue'


import XIcon from './components/index.vue'
Vue.component(XIcon.name, XIcon)
